import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import * as Constants from './../../application/constants'
import HelpIcon from '@material-ui/icons/Help'
import IconButton from '@material-ui/core/IconButton'
import Popper from '@material-ui/core/Popper'
import Fade from '@material-ui/core/Fade'
import ClickAwayListener from '@material-ui/core/ClickAwayListener'

export const PopperNote = ({ content }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  return (
    <React.Fragment>
      <Popper open={Boolean(anchorEl)} anchorEl={anchorEl} placement="bottom-start" transition>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Box bgcolor="background.popper" maxWidth={280}>
              <Note transparent={true}>{content}</Note>
            </Box>
          </Fade>
        )}
      </Popper>
      <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
        <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
          <HelpIcon/>
        </IconButton>
      </ClickAwayListener>
    </React.Fragment>
  )
}

const Note = ({ variant, children, alertIcon, transparent = false }) => {
  let color = null

  switch (true) {
    case variant === Constants.STATUS.ERROR || (variant === Constants.HEALTH_STATUS.CRITICAL):
      color = 'error.main'
      break
    case variant === Constants.STATUS.WARNING || (variant === Constants.HEALTH_STATUS.WARNING):
      color = 'status.warning'
      break
    case variant === Constants.STATUS.OK || (variant === Constants.HEALTH_STATUS.OK):
      color = 'status.ok'
      break
    default:
      color = 'text.primary'
      break
  }

  return (
    <Box p={2} bgcolor={transparent ? null : 'background.offset'} borderLeft={4} borderColor={color} display="flex" alignItems="center">
      {alertIcon && <Box flex={1} color={color} pr={2}>{alertIcon}</Box>}
      <Box flexGrow={1} width="100%">
        <Typography variant="body2">{children}</Typography>
      </Box>
    </Box>
  )
}

Note.propTypes = {
  variant: PropTypes.oneOf([
    Constants.HEALTH_STATUS.CRITICAL,
    Constants.HEALTH_STATUS.WARNING,
    Constants.HEALTH_STATUS.OK,
    Constants.STATUS.ERROR,
    Constants.STATUS.WARNING,
    Constants.STATUS.OK,
    'default'
  ]),
  alertIcon: PropTypes.object
}

export default Note
